<template>
    <div class="p-2 text-center font-sans text-gray-300 md:p-4">
    
        <BuyerSellerVanguard />

      <h1 class="text-3xl mt-6">Our Thoughts on Riot's Vanguard Anti-Cheat</h1>
        <p class="w-5/6 text-sm m-auto md:w-1/2">Updated June 2020</p>

    
    <p class="w-5/6 m-auto mt-4 md:w-1/2">Riot's unique kernel-level anti-cheat is the entire reason we created <span class="text-red-500">Valorant</span>Accounts. We believe that a unique program like this warrants a unique website specialized in mitigating potential issues surrounding account trading. </p>



<h1 class="text-3xl mt-6">Our Least-Suspicion Policy</h1>
<p class="w-5/6 m-auto md:w-1/2">Since Vanguard is still a new technology, our current efforts will revolve around making account trades look as legitimate as possible.</p>

<h1 class="text-xl mt-6">No Account Verification</h1>
<p class="w-5/6 m-auto md:w-1/2 mt-2">Due to the intrusive nature of Vanguard, we don't want to taint your account by logging into it. To make up for this, we put restrictions and fees on new Buyers and Sellers to only attract legitimate users to our service.</p>


<h1 class="text-xl mt-6">No Account Reselling</h1>
<p class="w-5/6 m-auto md:w-1/2 mt-2">We keep track of the Riot Accounts sold on our platform. Once a certain account has been sold, that same account cannot be listed again on <span class="text-red-500">Valorant</span>Accounts.net ever again.</p>

<h1 class="text-xl mt-6">Mandatory Hardware and Region Info</h1>
<p class="w-5/6 m-auto md:w-1/2 mt-2">Every listing is required to provide CPU, GPU, and Region info <span class="text-red-500">at the minimum.</span> Sellers are encouraged to be truthful due to our Any-Issue Refund available to Buyers.</p>


</div>
</template>

<script>
import BuyerSellerVanguard from './BuyerSellerVanguard'

export default {
  name: 'Vanguard',
  data() {
    return {

    }
  },
  components: {BuyerSellerVanguard},  
 beforeMount(){

 },    

}
</script>



// WEBPACK FOOTER //
// src/components/Vanguard.vue